import { create } from "zustand";
import { GridFilterPreference, GridOrderPreference, GridSortPreference, GridVisiblePreference } from "../../interfaces/Commons/Preferences/gridPreferences";
import { PreferenceType } from "../../interfaces/Commons/Preferences/preferences";

interface PreferencesTypes {
  preferenceTypes: PreferenceType[];
  setPreferencesTypes: (by: PreferenceType[]) => void;
  getPreferenceTypeIdByPreferenceName: (preferenceTypeName: string) => number | undefined;
}

export const usePreferenceTypesStore = create<PreferencesTypes>((set, get) => ({
  preferenceTypes: [],
  setPreferencesTypes: (preferenceTypes: PreferenceType[]) => {
    set({ preferenceTypes });
  },
  getPreferenceTypeIdByPreferenceName: (preferenceTypeName: string) => {
    return get().preferenceTypes.find((preferenceType) => preferenceType.preference_type_name === preferenceTypeName)?.preference_type_id;
  }
}));

interface GridColumnOrderPreferences {
  gridColumnOrderPreferences: GridOrderPreference[];
  setColumnOrderPreferences: (by: GridOrderPreference[]) => void;
  addColumnOrderPreference: (by: GridOrderPreference) => void;
  updateColumnOrderPreference: (by: GridOrderPreference) => void;
  getColumnOrderPreferenceByResourceId: (resourceId: number) => GridOrderPreference | undefined;
}

export const useGridColumnOrderPreferencesStore = create<GridColumnOrderPreferences>((set, get) => ({
  gridColumnOrderPreferences: [],
  setColumnOrderPreferences: (gridColumnOrderPreferences: GridOrderPreference[]) => {
    set({ gridColumnOrderPreferences });
  },
  addColumnOrderPreference: (by: GridOrderPreference) => {
    set((state) => ({
      gridColumnOrderPreferences: [...state.gridColumnOrderPreferences, by]
    }));
  },
  updateColumnOrderPreference: (by: GridOrderPreference) => {
    set((state) => ({
      gridColumnOrderPreferences: state.gridColumnOrderPreferences.map((gridColumnOrderPreference) =>
        gridColumnOrderPreference.resource_id === by.resource_id ? by : gridColumnOrderPreference
      ),
    }));
  },
  getColumnOrderPreferenceByResourceId: (resourceId: number) => {
    return get().gridColumnOrderPreferences.find((preference) => preference.resource_id === resourceId);
  }
}));

interface GridColumnVisiblePreferences {
  gridColumnVisiblePreferences: GridVisiblePreference[];
  setColumnVisiblePreferences: (by: GridVisiblePreference[]) => void;
  addColumnVisiblePreference: (by: GridVisiblePreference) => void;
  updateColumnVisiblePreference: (by: GridVisiblePreference) => void;
  getColumnVisualPreferenceByResourceId: (resourceId: number) => GridVisiblePreference | undefined;
}

export const useGridColumnVisiblePreferencesStore = create<GridColumnVisiblePreferences>((set, get) => ({
  gridColumnVisiblePreferences: [],
  setColumnVisiblePreferences: (gridColumnVisiblePreferences: GridVisiblePreference[]) => {
    set({ gridColumnVisiblePreferences });
  },
  addColumnVisiblePreference: (by: GridVisiblePreference) => {
    set((state) => ({
      gridColumnVisiblePreferences: [...state.gridColumnVisiblePreferences, by]
    }));
  },
  updateColumnVisiblePreference: (by: GridVisiblePreference) => {
    set((state) => ({
      gridColumnVisiblePreferences: state.gridColumnVisiblePreferences.map((gridColumnVisiblePreference) =>
        gridColumnVisiblePreference.resource_id === by.resource_id ? by : gridColumnVisiblePreference
      ),
    }));
  },
  getColumnVisualPreferenceByResourceId: (resourceId: number) => {
    return get().gridColumnVisiblePreferences.find((preference) => preference.resource_id === resourceId);
  }
}));

interface GridFilterPreferences {
  gridColumnFilterPreferences: GridFilterPreference[];
  setColumnFilterPreferences: (by: GridFilterPreference[]) => void;
  addColumnFilterPreference: (by: GridFilterPreference) => void;
  updateColumnFilterPreference: (by: GridFilterPreference) => void;
  getColumnFilterPreferenceByResourceId: (resourceId: number) => GridFilterPreference | undefined;
}

export const useGridFilterPreferencesStore = create<GridFilterPreferences>((set, get) => ({
  gridColumnFilterPreferences: [],
  setColumnFilterPreferences: (gridColumnFilterPreferences: GridFilterPreference[]) => {
    set({ gridColumnFilterPreferences });
  },
  addColumnFilterPreference: (by: GridFilterPreference) => {
    set((state) => ({
      gridColumnFilterPreferences: [...state.gridColumnFilterPreferences, by]
    }));
  },
  updateColumnFilterPreference: (by: GridFilterPreference) => {
    set((state) => ({
      gridColumnFilterPreferences: state.gridColumnFilterPreferences.map((gridColumnFilterPreference) =>
        gridColumnFilterPreference.resource_id === by.resource_id ? by : gridColumnFilterPreference
      ),
    }));
  },
  getColumnFilterPreferenceByResourceId: (resourceId: number) => {
    return get().gridColumnFilterPreferences.find((preference) => preference.resource_id === resourceId);
  }
}));

interface GridColumnSortPreferences {
  gridColumnSortPreferences: GridSortPreference[];
  setColumnSortPreferences: (by: GridSortPreference[]) => void;
  addColumnSortPreference: (by: GridSortPreference) => void;
  updateColumnSortPreference: (by: GridSortPreference) => void;
  getColumnSortPreferenceByResourceId: (resourceId: number) => GridSortPreference | undefined;
}

export const useGridColumnSortPreferencesStore = create<GridColumnSortPreferences>((set, get) => ({
  gridColumnSortPreferences: [],
  setColumnSortPreferences: (gridColumnSortPreferences: GridSortPreference[]) => {
    set({ gridColumnSortPreferences });
  },
  addColumnSortPreference: (by: GridSortPreference) => {
    set((state) => ({
      gridColumnSortPreferences: [...state.gridColumnSortPreferences, by]
    }));
  },
  updateColumnSortPreference: (by: GridSortPreference) => {
    set((state) => ({
      gridColumnSortPreferences: state.gridColumnSortPreferences.map((gridColumnSortPreference) =>
        gridColumnSortPreference.resource_id === by.resource_id ? by : gridColumnSortPreference
      ),
    }));
  },
  getColumnSortPreferenceByResourceId: (resourceId: number) => {
    return get().gridColumnSortPreferences.find((preference) => preference.resource_id === resourceId);
  }
}));